import React from "react";
import { Container } from "react-bootstrap";

const AuthSuccess = () => {
    return (
        <Container>
            Login successfully. You may close the browser tab now.
        </Container>
    );
};

export default AuthSuccess;
